import { gsap } from 'gsap';
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

function logosCarousel() {
    const carouselContainers = document.querySelectorAll('.logos-carousel-container');
    
    carouselContainers.forEach(container => {
        const track = container.querySelector('.logos-carousel-track');
        if (!track) return;
        
        const items = Array.from(track.querySelectorAll('.logos-carousel-item'));
        if (items.length === 0) return;

        // Duplicate items for seamless loop
        items.forEach(item => {
            const clone = item.cloneNode(true);
            track.appendChild(clone);
        });

        const itemWidth = 220;
        const gap = 70;
        const totalSetWidth = (itemWidth + gap) * items.length;

        // GSAP loop
        const loop = gsap.fromTo(track, 
            { x: 0 },
            {
                x: -totalSetWidth,
                duration: totalSetWidth / 40, // Consistent speed: 40px/sec
                ease: 'none',
                repeat: -1,
                force3D: true
            }
        );

        // Dragging & Interaction logic
        let isDragging = false;
        let startX = 0;
        let startTranslateX = 0;

        const onStart = (e) => {
            isDragging = true;
            loop.pause();
            startX = e.pageX || e.touches?.[0].pageX;
            startTranslateX = gsap.getProperty(track, "x");
            container.style.cursor = 'grabbing';
        };

        const onMove = (e) => {
            if (!isDragging) return;
            const currentX = e.pageX || e.touches?.[0].pageX;
            const diff = currentX - startX;
            let newX = startTranslateX + diff;
            
            // Wrap the position for infinite feel
            if (newX > 0) {
                newX -= totalSetWidth;
                startTranslateX -= totalSetWidth;
            } else if (newX < -totalSetWidth) {
                newX += totalSetWidth;
                startTranslateX += totalSetWidth;
            }
            
            gsap.set(track, { x: newX });
        };

        const onEnd = () => {
            if (!isDragging) return;
            isDragging = false;
            container.style.cursor = 'grab';
            
            // Calculate progress to keep loop seamless
            const currentX = gsap.getProperty(track, "x");
            const progress = Math.abs(currentX) / totalSetWidth;
            loop.progress(progress % 1);
            loop.play();
        };

        container.style.cursor = 'grab';
        container.addEventListener('mousedown', onStart);
        window.addEventListener('mousemove', onMove);
        window.addEventListener('mouseup', onEnd);
        
        container.addEventListener('touchstart', onStart, { passive: true });
        window.addEventListener('touchmove', onMove, { passive: false });
        window.addEventListener('touchend', onEnd);

        container.addEventListener('mouseenter', () => loop.pause());
        container.addEventListener('mouseleave', () => {
            if (!isDragging) loop.play();
        });

        // Initialize Fancybox for individual logo clicks
        Fancybox.bind(container, '[data-fancybox]', {
            mainClass: 'fancybox-logos-carousel',
            Carousel: {
                friction: 1.8,
                preload: 1,
                infinite: true,
                Navigation: false,
                Dots: false
            }
        });
    });
}

function ctaAndLogos() {
    logosCarousel();
}

export default ctaAndLogos;